import axios from 'axios';
import cookie from '../../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function getUserByEmail(userEmail) {
    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/userByEmail/${userEmail}`;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return axios
        .get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
        .then(res => {
            // console.log("Response: ", res);
            return res.data.data;
        })
        .catch(err => {
            // console.error("Error: ", err);
            return err;
        });
}
